// Granular Refresh spec §2.6. Top-of-modal warning: for each CURRENTLY
// selected field, how many of the selected rows carry a customised value
// that the refresh would overwrite. Recomputed by the modal as checkboxes
// toggle; this component just renders the resolved lines. Renders nothing
// when no selected field has conflicts (the warning disappears entirely).

export type ConflictLine = { label: string; rows: number };

export function ConflictWarning({ lines }: { lines: ConflictLine[] }) {
  if (lines.length === 0) return null;
  return (
    <div className="rounded-md border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900">
      <p className="font-medium">⚠ Custom values to be overwritten:</p>
      <ul className="mt-1 list-disc space-y-0.5 pl-5">
        {lines.map((l) => (
          <li key={l.label}>
            {l.rows} {l.rows === 1 ? 'row has' : 'rows have'} custom {l.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
